import { useState, useRef } from 'react';
import { AlertTimeIcon, CloseIcon } from '../';
import { daysBetweenDates, reminderTagClassName, getCardTagText, isCardTagHidden } from '../../utils';
import { useDispatch } from 'react-redux';
import { markAsIncomplete } from '../../actions/content_group.actions';
import { content_group } from '../../reducers/content_group.reducer';
import { userConstants } from '../../constants';
import { alertActions } from '../../actions';

function tagSizeClass(size) {
  if(size === 'lg'){
    return 'tag-large'
  }

  return ''
}

function CardTag(props) {
  const {
    completed,
    reminder_in_day,
    due_date,
    useVisibility,
    className,
    size,
    can_access_content,
    workspace_id,
    card_id
  } = props;

  const dateTimeToday = new Date();
  const dateToday = new Date();
  const dueDate = new Date(due_date);
  const past_due = due_date ? dateTimeToday > new Date(due_date) :  false;
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);

  dueDate?.setHours(0,0,0,0);
  dateToday?.setHours(0,0,0,0);

  const diff_in_day = (past_due || due_date === undefined) ? 0 : daysBetweenDates(dateToday, dueDate);

  const isHidden = () => {
      return isCardTagHidden(completed, reminder_in_day, due_date, diff_in_day)
  }

  const style = () => {
    if(useVisibility === undefined) return {};

    return { visibility: isHidden() ? 'hidden' : 'visible'}
  }

  const handleMarkAsIncomplete = (e) => {
    e.stopPropagation();

    if(isDisabled) return;

    const onBefore = () => {
      setIsDisabled(true);
    }

    const onFinally = () => {
      setIsDisabled(false);
    }

    const onCatch = () =>{
      setIsDisabled(false)
    }

    const onError = (response) => {
      dispatch(alertActions.error(response.data.error))
    }

    const onSuccess = (response) => {
      dispatch({ type: userConstants.UPDATE_CONTENTGROUP, payload: response })
    }

    const params = {
      workspace_id,
      card_id,
      onBefore,
      onFinally,
      onCatch,
      onError,
      onSuccess
    }

    dispatch(markAsIncomplete(params));
  }

  if(isHidden() && useVisibility === undefined) return null;

  return (
    <div className={`tag ${className} ${tagSizeClass(size)} ${reminderTagClassName(past_due ? -1 : diff_in_day, completed)}`}
         style={style()}>
         <div className="d-flex align-items-center justify-content-between h-100">
            <div className='d-flex align-items-center'>
              <AlertTimeIcon />
              <span>{getCardTagText(past_due ? -1 : diff_in_day, completed)}</span>
            </div>
          {
            completed && can_access_content && 
            <button 
              className="btn btn-link p-0 remove-complete-btn m-0 align-items-center" 
              onClick={handleMarkAsIncomplete}
              disabled={isDisabled}
            >
              <CloseIcon height={16} width={16} className='m-0'/>
            </button>
          }
         </div>
    </div>
  );
}

export { CardTag };
